import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { useForm, Link } from '@inertiajs/react'
import FormField from '../../components/FormField'
import Button from '../../components/Button'

export default function InvitationsNew({ team }) {
  const { data, setData, post, processing, errors } = useForm({
    role: 'member',
    expires_at: '',
  })

  function handleSubmit(e) {
    e.preventDefault()
    post(`/teams/${team.id}/invitations`)
  }

  return (
    <AuthenticatedLayout>
      <div className="max-w-lg">
        <div className="mb-6">
          <Link href={`/teams/${team.id}`} className="text-sm text-indigo-600 hover:underline">
            ← {team.name}
          </Link>
          <h1 className="text-2xl font-bold text-gray-900 mt-2">Skapa inbjudningslänk</h1>
        </div>
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <FormField label="Roll" error={errors.role}>
              <select
                value={data.role}
                onChange={e => setData('role', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                <option value="member">Medlem</option>
                <option value="admin">Lagadmin</option>
              </select>
            </FormField>

            <FormField label="Går ut (valfritt)" error={errors.expires_at}>
              <input
                type="datetime-local"
                value={data.expires_at}
                onChange={e => setData('expires_at', e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </FormField>

            <div className="flex gap-3">
              <Button type="submit" disabled={processing}>
                {processing ? 'Skapar…' : 'Skapa inbjudningslänk'}
              </Button>
              <Link href={`/teams/${team.id}`}>
                <Button type="button" variant="secondary">Avbryt</Button>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
